import React from "react";
import { useTranslation } from "react-i18next";
import Badge from "@/components/ui/badge";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";
import { getOnboardingStageBadgeClassName } from "@/pages/settings/components/contractsSettings/onboardingStudio/colors";
import { useOnboardingStages } from "@/pages/settings/components/contractsSettings/hooks";
import { ContractTableRow } from "@/pages/contracts/types";

interface Props {
  row: ContractTableRow;
}

const OnboardingStageCell: React.FC<Props> = ({ row }) => {
  const { t } = useTranslation();
  const { data: stagesResponse } = useOnboardingStages();

  if (row.onboardingCompletedAt) {
    return (
      <Badge className="border-border-secondary-button">
        <Text variant="smBody">
          {t("contracts.table.onboardingStage.completed")}
        </Text>
      </Badge>
    );
  }

  if (!row.onboardingStartDate) {
    return (
      <Badge className="border-border-secondary-button">
        <Text variant="smBody">
          {t("contracts.table.onboardingStage.notStarted")}
        </Text>
      </Badge>
    );
  }

  const stage =
    stagesResponse?.stages.find((s) => s.id === row.onboardingStageId) ?? null;

  const badgeClassName = stage
    ? getOnboardingStageBadgeClassName(stage.stageColor)
    : "border-border-secondary-button bg-surface-tags-blue border-tags-blue";

  return (
    <Badge className={cn(badgeClassName)}>
      <Text variant="smBody">
        {stage?.name ?? t("contracts.table.onboardingStage.onboarding")}
      </Text>
    </Badge>
  );
};

export default OnboardingStageCell;
